const priceOfferTypes = {
  CHARTER: 'CHARTER',
  INDEPENDENT: 'INDEPENDENT',
  CRUISE: 'CRUISE',
  HOTEL_ONLY: 'HOTEL_ONLY',
  GEOGRAPHICAL: 'GEOGRAPHICAL',
};

export default priceOfferTypes;
